const firebaseConfig = {
    apiKey: "AIzaSyBq7-kgSWZ9KQg4y3VKa6AmJ_xU9IeU46k",
    authDomain: "assignment-09-ac349.firebaseapp.com",
    projectId: "assignment-09-ac349",
    storageBucket: "assignment-09-ac349.appspot.com",
    messagingSenderId: "495660141862",
    appId: "1:495660141862:web:b03ce598785171a25505e7"
  };
export default firebaseConfig;